import React from 'react';
import Button from 'src/ui/library/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Checkbox from 'src/ui/library/Checkbox';

export default function ServiceDetailsPres({ onSave, onUpdatePolicy, policyList }) {
  const { defaultServices, additionalServices } = policyList;

  return (
    <Dialog maxWidth={false} classes={{ root: 'service-details', paper: 'service-details paper' }} open={true}>
      <h2 className="title" id="confirm-title">
        Service Details
      </h2>
      <DialogContent classes={{ root: 'content-root' }}>
        <DialogContentText classes={{ root: 'content-text' }}>
          <section className="policy-section">
            <h3>Default Policy Services</h3>
            {defaultServices.map(service => (
              <Checkbox
                checked={service.isSelected}
                key={service.serviceId}
                label={service.serviceName}
                onChange={() => onUpdatePolicy('defaultServices', service.serviceId)}
              />
            ))}
          </section>
          <section className="policy-section">
            <h3>Additional Services</h3>
            {additionalServices.map(service => (
              <Checkbox
                checked={service.isSelected}
                key={service.serviceId}
                label={service.serviceName}
                onChange={() => onUpdatePolicy('additionalServices', service.serviceId)}
              />
            ))}
          </section>
        </DialogContentText>
      </DialogContent>
      <DialogActions classes={{ root: 'actions-container' }}>
        <Button onClick={onSave} noMaxWidth={true}>
          Save Service Policies
        </Button>
      </DialogActions>
    </Dialog>
  );
}
